import React from "react";
import ChangePasswordForm from "./ChangePasswordForm";
import MainPageCompenent from './MainPageCompenent';
function ChangePassword(props) {
    return (
        <MainPageCompenent>
            <ChangePasswordForm />
        </MainPageCompenent>
    );
}

export default ChangePassword;